import { Tabs } from '@mantine/core';
import type { LivestockType } from '@/types/livestock';
import { LIVESTOCK_TYPE_META } from './constants';

interface LivestockTypeFilterProps {
  value: string | null;
  onChange: (value: string | null) => void;
}

const TYPE_TABS = (Object.keys(LIVESTOCK_TYPE_META) as LivestockType[]).map((type) => ({
  value: type,
  label: LIVESTOCK_TYPE_META[type].label,
  Icon: LIVESTOCK_TYPE_META[type].Icon,
}));

export function LivestockTypeFilter({ value, onChange }: LivestockTypeFilterProps) {
  return (
    <Tabs
      value={value ?? 'all'}
      onChange={(v) => onChange(v === 'all' ? null : v)}
    >
      <Tabs.List>
        <Tabs.Tab value="all">All</Tabs.Tab>
        {TYPE_TABS.map((tab) => (
          <Tabs.Tab
            key={tab.value}
            value={tab.value}
            leftSection={<tab.Icon size={16} />}
          >
            {tab.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  );
}
